import toPromise from 'lib/to-promise';

var ResourceService = function() {
  this.getResources = function(resourceType, resourceSubType){
    // note resourceSubType is actually the slug
    return toPromise(EF.resources.byType(resourceType, resourceSubType));
  };

  this.loadResources = function () {
    return toPromise(EF.resources.fetch());
  }

  this.save = function(resourceItem) {
    return resourceItem.save();
  };
};

module.exports = new ResourceService();



